/**
 * bugsnagUtil
 *
 * Shared Bugsnag configuration helpers used in both App.js (global onError
 * filter) and ErrorBoundary (componentDidCatch filter).  Keeping the list in
 * one place ensures the two code paths stay in sync.
 */

/**
 * Error messages that represent expected auth failures and should never be
 * reported to Bugsnag.  These are thrown by baseApi.js (or the legacy PHP
 * layer) when a session has expired or the user lacks permission.
 */
// eslint-disable-next-line import/prefer-default-export
export const bugsnagDiscardedMessages = [
  'Invalid token',
  'Expired token',
  'Unauthorized'
];
